import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { WidgetLayout } from '../shared/WidgetLayout/WidgetLayout';
import { CardLayout } from '../shared/CardLayout/CardLayout';
import { Box, Text } from '@wix/design-system';
import { WidgetButton } from '../shared/WidgetButton/WidgetButton';
import { WithMarkdown } from '../shared/WithMarkdown/WithMarkdown';
import { Picture } from '../shared/Picture/Picture';
import { useDisabledWidget } from '../../../shared/disabled-widget/useDisabledWidget';
import { WithDisabledControl } from '../../../shared/disabled-widget/WithDisabledControl';
export const SingleSelectWidget = _ref => {
  var _data$options, _data$secondaryButton, _data$primaryButton;
  let {
    data,
    context,
    config
  } = _ref;
  const {
    areControlsDisabled,
    enableControls
  } = useDisabledWidget(config);
  const handleButtonClick = function (action, label) {
    if (label === void 0) {
      label = '';
    }
    const handler = effects => {
      const onWidgetActionData = {
        action,
        value: {
          label,
          effects
        }
      };
      context.onWidgetAction(SINGLE_SELECT_WIDGET, onWidgetActionData, data.text);
    };
    return handler;
  };
  const cards = (data.options ?? []).map(_ref2 => {
    let {
      picture,
      title,
      button,
      text,
      value
    } = _ref2;
    return /*#__PURE__*/React.createElement(CardLayout, {
      key: value,
      borderless: data.borderlessOptions
    }, (picture == null ? void 0 : picture.url) && /*#__PURE__*/React.createElement(Picture, _extends({}, picture, {
      aspectRatio: "3/2"
    })), (title || button) && /*#__PURE__*/React.createElement(Box, {
      align: "space-between",
      verticalAlign: "middle",
      gap: "SP1"
    }, title && /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      weight: "bold"
    }, title), button && /*#__PURE__*/React.createElement(WithDisabledControl, {
      isDisabled: areControlsDisabled,
      onEnable: enableControls,
      t: context.t
    }, /*#__PURE__*/React.createElement(WidgetButton, {
      priority: "secondary",
      selectedValues: [value],
      selectedTitles: [title ?? ''],
      respondText: button.respondText,
      webAction: button.webAction,
      context: context,
      icon: button.icon,
      sideEffect: button.sideEffect,
      onClick: handleButtonClick('option_button_click', button.label),
      skin: button.skin,
      disabled: areControlsDisabled
    }, button.label))), text && /*#__PURE__*/React.createElement(WithMarkdown, null, text));
  });
  return /*#__PURE__*/React.createElement(WidgetLayout, {
    badge: data.badge,
    text: data.text,
    secondaryButton: data.secondaryButton,
    primaryButton: data.primaryButton,
    context: context,
    selectedValues: ((_data$options = data.options) == null ? void 0 : _data$options.map(option => option.value)) ?? [],
    onSecondaryButtonClick: handleButtonClick('secondary_button_click', (_data$secondaryButton = data.secondaryButton) == null ? void 0 : _data$secondaryButton.label),
    onPrimaryButtonClick: handleButtonClick('primary_button_click', (_data$primaryButton = data.primaryButton) == null ? void 0 : _data$primaryButton.label),
    footerButtonsAsColumn: data.footerButtonsAsColumn,
    gap: data.borderlessOptions ? 'big' : 'normal',
    bottomText: data.bottomText,
    disabled: areControlsDisabled,
    onEnableControls: enableControls
  }, !!cards.length && cards);
};
export const SINGLE_SELECT_WIDGET = 'SINGLE_SELECT_WIDGET';
//# sourceMappingURL=SingleSelectWidget.js.map